












// vendor
import { defineComponent, computed, PropType } from "@vue/composition-api";
// local
import * as ItemTypes from "../ts/ItemTypes";
import { FormItem } from "../ts/types";

export default defineComponent({
	props:{
		data:{
			type:Object as PropType<FormItem<any>>,
			required:true
		}
	},
	setup(props){

		const hideName = computed(() => props.data.hideName);
		const type = computed(() => props.data.type);

		const component = computed(() => {
			const i = (ItemTypes as any)[type.value];
			return i ? i.preview : ItemTypes["Default"].preview;
		});

		return {
			hideName,
			type,
			component
		};
	}
});

